import React from 'react'

import courseFirstEdition from '../assets/img/formacion-ub/course-2023-2024.png'
import courseSecondEdition from '../assets/img/formacion-ub/course-2024-2025.png'
import classPhoto from '../assets/img/formacion-ub/class-2024.jpeg'
import jornadasPoster from '../assets/img/formacion-ub/jornadas-2026.png'
import NewsletterCTA from '../components/NewsletterCTA'

import './ub-training-page.scss'

const UbTrainingPage = () => (
  <article className='ub-training-page'>
    <header className='ub-training-page__hero'>
      <div className='ub-training-page__hero-orbit' aria-hidden='true' />
      <div className='ub-training-page__shell ub-training-page__hero-grid'>
        <div className='ub-training-page__hero-copy'>
          <p className='ub-training-page__eyebrow'>Formación UB · Desde 2023</p>
          <h1>Curso Superior Universitario en Educación Menstrual</h1>
        </div>
        <p className='ub-training-page__lead'>
          Desde 2023, la Universitat de Barcelona ofrece la primera formación de postgrado en Educación menstrual de una universidad pública del Estado. Se trata de un proyecto nacido en la Facultad de Educación y desarrollado en convenio con <strong><em>La Vida en Rojo</em>, Asociación de Cultura Menstrual</strong>, con la que comparte docentes, mirada y recorrido desde su primera edición.
        </p>
      </div>
    </header>

    <main>
      <section className='ub-training-page__section ub-training-page__origin'>
        <div className='ub-training-page__shell'>
          <div className='ub-training-page__section-heading'>
            <span>01</span>
            <div>
              <p>Cómo empezó</p>
              <h2>Origen</h2>
            </div>
          </div>

          <blockquote className='ub-training-page__testimony'>
            <p className='ub-training-page__testimony-label'>Testimonio de Mª Victoria López Benito, codirectora del curso</p>
            <p>«Se creó la primera formación de postgrado en la Universidad de Barcelona como Curso Superior Universitario en Educación Menstrual en el curso 2023-24 después de diversas acciones educativas llevadas a cabo en cursos anteriores en la Facultad de Educación. Concretamente, se realizaron dos seminarios sobre Educación menstrual para la formación docente con mirada feminista en el marco de los seminarios complementarios para los grados de educación infantil y primaria. Estos seminarios fueron posibles gracias al impulso de la profesora Elvira Barriga del departamento de didácticas aplicadas y los realizamos conjuntamente yo misma, Victoria López Benito, y Ana Luisa Meza Ferrari.</p>
            <p>Los seminarios abrieron la puerta a la creación del primer Curso Superior Universitario en Educación Menstrual debido a mi deseo personal por llevar esta temática de manera estable y continuada a la formación en la Universidad y en concreto a la Facultad de Educación de la Universidad de Barcelona, y también gracias a la buena acogida de este deseo por parte del equipo decanato de la Facultad.</p>
            <p>Esta primera formación de postgrado sobre Educación menstrual en una universidad pública tenía los siguientes objetivos: dar a conocer las bases teóricas y prácticas de la educación menstrual desde la perspectiva de la salud, las condiciones socioculturales y sus principales ámbitos de aplicación e intervención. También adquirir los conocimientos necesarios para percibir el hecho de menstruar desde una mirada positiva, inclusiva, sostenible e integral partiendo del autoconocimiento y reconocimiento menstrual y cíclico. Y finalmente aportar recursos materiales y didácticos y las experiencias de profesionales de la salud y la educación menstrual para poder resignificar lo que sabemos sobre nuestro ciclo menstrual y ser capaces de aplicar estos conocimientos a la práctica educativa y a otros ámbitos profesionales.»</p>
          </blockquote>
        </div>
      </section>

      <section className='ub-training-page__section ub-training-page__involvement'>
        <div className='ub-training-page__shell ub-training-page__split'>
          <figure className='ub-training-page__class-photo'>
            <img src={classPhoto} alt='Grupo participante en una clase semipresencial de Educación Menstrual en 2024' />
            <figcaption>Clase semipresencial · 2024</figcaption>
          </figure>
          <div className='ub-training-page__split-copy'>
            <div className='ub-training-page__section-heading ub-training-page__section-heading--compact'>
              <span>02</span>
              <div>
                <p>Trabajo compartido</p>
                <h2>Implicación desde el inicio</h2>
              </div>
            </div>
            <p>Desde la primera edición, Mª Victoria López Benito —codirectora del curso junto a Ilaria Bellati, de la Facultad de Educación de la Universitat de Barcelona— convocó a sus compañeras cofundadoras de <strong><em>La Vida en Rojo</em></strong>, Ana Luisa Meza Ferrari y Carolina Ackermann Barreiro, así como a Núria Beitia Hernández, vocal de la Asociación, para participar en la docencia. Por ello, desde el primer momento se hizo difusión de la formación desde las redes de la Asociación, y la vinculación con la Universitat de Barcelona se vivió de manera informal mucho antes de su formalización.</p>
          </div>
        </div>
      </section>

      <section className='ub-training-page__section ub-training-page__journey'>
        <div className='ub-training-page__shell'>
          <div className='ub-training-page__section-heading'>
            <span>03</span>
            <div>
              <p>Ediciones y encuentros</p>
              <h2>Trayectoria</h2>
            </div>
          </div>

          <div className='ub-training-page__timeline'>
            <article className='ub-training-page__milestone'>
              <div className='ub-training-page__milestone-copy'>
                <p className='ub-training-page__year'>2023—2024</p>
                <h3>1ª edición</h3>
                <p className='ub-training-page__facts'>Formación on-line · 125 horas · 5 créditos ECTS</p>
                <p>Del 7 de marzo al 13 de junio de 2024</p>
              </div>
              <figure className='ub-training-page__poster'>
                <img src={courseFirstEdition} alt='Cartel de la primera edición del Curso Superior Universitario en Educación Menstrual, 2023-2024' />
              </figure>
            </article>

            <article className='ub-training-page__milestone ub-training-page__milestone--reverse'>
              <div className='ub-training-page__milestone-copy'>
                <p className='ub-training-page__year'>2024—2025</p>
                <h3>2ª edición</h3>
                <p className='ub-training-page__facts'>Formación on-line · 125 horas · 5 créditos ECTS</p>
                <p>Del 7 de noviembre de 2024 al 20 de febrero de 2025</p>
              </div>
              <figure className='ub-training-page__poster'>
                <img src={courseSecondEdition} alt='Cartel de la segunda edición del Curso Superior Universitario en Educación Menstrual, 2024-2025' />
              </figure>
            </article>

            <article className='ub-training-page__milestone ub-training-page__milestone--jornadas'>
              <div className='ub-training-page__milestone-copy'>
                <p className='ub-training-page__year'>5—6 FEB · 2026</p>
                <h3>I Jornadas de Educación Menstrual</h3>
                <p>La Facultad de Educación impulsó, bajo la coordinación de Ma. Victoria López Benito e Ilaria Bellati las primeras Jornadas de Educación Menstrual, celebradas el 5 y 6 de febrero de 2026 en la Facultad de Educación de la UB. El encuentro reunió a profesionales de la educación menstrual y de ámbitos afines para reflexionar sobre los proyectos emergentes y los retos actuales del sector, más allá del espacio de formación académica del propio postgrado.</p>
              </div>
              <figure className='ub-training-page__poster ub-training-page__poster--wide'>
                <img src={jornadasPoster} alt='Cartel de las I Jornadas de Educación Menstrual celebradas en febrero de 2026' />
              </figure>
            </article>
          </div>
        </div>
      </section>

      <section className='ub-training-page__section ub-training-page__future'>
        <div className='ub-training-page__shell'>
          <div className='ub-training-page__section-heading ub-training-page__section-heading--light'>
            <span>04</span>
            <div>
              <p>Presente y futuro</p>
              <h2>Una alianza que crece</h2>
            </div>
          </div>
          <div className='ub-training-page__future-grid'>
            <article>
              <p className='ub-training-page__future-number'>2026</p>
              <h2>El convenio</h2>
              <p>El 26 de febrero de 2026, la Universitat de Barcelona y La Vida en Rojo, Asociación de Cultura Menstrual, firmaron el convenio de colaboración para la realización de cursos de formación permanente en Educación menstrual. Un paso más en una relación de trabajo conjunto que, en la práctica, ya se sostenía desde la primera edición del curso.</p>
            </article>
            <article className='ub-training-page__expert-card'>
              <p className='ub-training-page__future-number'>2027</p>
              <h2>Ampliación: hacia el Curso de Experta</h2>
              <p>La Agencia de Postgrados de la Universitat de Barcelona ha aprobado la ampliación de la formación: el Curso superior universitario, de 5 créditos ECTS, pasa a la categoría de Curso de Experta, con 20 créditos ECTS. La nueva formación comenzará en febrero de 2027.</p>
              <a href='https://web.ub.edu/ca/web/estudis/w/masterpropi-202512284?referer=cercador-masters-postgraus' target='_blank' rel='noreferrer'>
                Más información <span aria-hidden='true'>↗</span>
              </a>
            </article>
          </div>
        </div>
      </section>
    </main>
    <NewsletterCTA />
  </article>
)

export default UbTrainingPage
